import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HandleErrorModule } from '@core/components/handle-errors/handle-errors.module';
import { MicroFrontendsModule } from '@xdig/ng-microkernel/micro-frontend';
import { DefaultComponent } from './default.component';
import { OutOfTimeModule } from '@core/components/out-office/out-office.module';
import { BackendTimeEndpoint } from '@core/endpoints/backend-time.endpoint';
import { ModalModule } from '../../../shared/errors/modal/modal.module';

@NgModule({
  declarations: [DefaultComponent],
  exports: [DefaultComponent],
  imports: [
    CommonModule,
    RouterModule,
    MicroFrontendsModule,
    ModalModule,
    HandleErrorModule,
    OutOfTimeModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [BackendTimeEndpoint],
})
export class DefaultModule {}
